module.exports = __webpack_public_path__ + "static/media/Francesca Chua.a18a3a13.png";